import ESignSettings from 'vcomponents/esign/ESignSettings.vue';
import ESignSettingsProviders from 'vcomponents/esign/ESignSettingsProviders.vue';
import VatSettings from 'vcomponents/settings/taxes/VatSettings.vue';
import Settings from 'vcomponents/Settings.vue';
import SettingsPage from 'vcomponents/pages/settings/SettingsPage.vue';
import SettingsHome from 'vcomponents/settings/SettingsHome.vue';
import SettingsInternalPlugin from 'vcomponents/settings/SettingsInternalPlugin.vue';
import SettingsExternalPlugin from 'vcomponents/settings/SettingsExternalPlugin.vue';

export default [
    {
        path: '/rest/custom/lang',
        name: 'legacy.settings.lang',
    },
    {
        path: '/rest/customtag/:context',
        name: 'legacy.settings.customtag',
    },
    {
        path: '/rest/documents/display-preferences/:docPrefsId',
        name: 'legacy.settings.display.preferences',
    },
    {
        path: '/settings',
        component: SettingsPage,
        redirect: 'settings/home/general',
        children: [
            {
                path: 'esign',
                name: 'settings.esign',
                component: ESignSettings,
                children: [
                    {
                        path: '/',
                        redirect: 'providers',
                    },
                    {
                        name: 'settings.esign.providers',
                        path: 'providers',
                        component: ESignSettingsProviders,
                    },
                ],
            },
            {
                path: 'vat',
                name: 'settings.vat',
                component: VatSettings,
            },
            {
                path: 'externals',
                redirect: { name: 'settings.home.external' },
                component: Settings,
                meta: {
                    title: window.i18n.__('Réglages'),
                },
                children: [
                    {
                        path: ':pluginPrefsToLoad',
                        name: 'settings.home.external.plugin',
                        component: SettingsExternalPlugin,
                        meta: {
                            state: 'externals',
                        },
                        props: true,
                    },
                ],
            },
            {
                path: 'plugins',
                redirect: { name: 'settings.home.internal' },
            },
            {
                path: 'home',
                name: 'settings.home',
                redirect: 'general',
                component: Settings,
                meta: {
                    title: window.i18n.__('Réglages'),
                },
                children: [
                    {
                        path: 'general',
                        name: 'settings.home.general',
                        component: SettingsHome,
                        meta: {
                            state: 'settings',
                        },
                    },
                    {
                        path: 'internal',
                        name: 'settings.home.internal',
                        component: SettingsInternalPlugin,
                        meta: {
                            state: 'plugins',
                        },
                    },
                    {
                        path: 'external',
                        name: 'settings.home.external',
                        component: SettingsExternalPlugin,
                        meta: {
                            state: 'externals',
                        },
                    },
                ],
            },
            {
                path: '*',
                beforeEnter: (to, from, next) => {
                    const regex = new RegExp(
                        '(^\\/settings\\/imports(\\?(import(Type)?=.+))?(#importAnchor)?$)|([?&]_f)|(^\\/settings\\/consent\\-history$)|(^\\/settings\\/email$)',
                        'g',
                    );
                    // We check if next route is not a legacy route to redirect to notFound
                    // nor settings/imports (with/without query params import and importType
                    if (!regex.test(to.fullPath) && !to.fullPath.contains('/settings/email')) {
                        next({ name: 'error.not.found' });
                    }
                },
            },
        ],
    },
];
